import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetUsersEnrichmentResponse } from './get-users-enrichment-response';
import { getUsersEnrichmentResponseSchema } from './get-users-enrichment-response';

export async function getUsersEnrichmentApi(): Promise<
  IValidatedResponse<IGetUsersEnrichmentResponse>
> {
  return getRequest<IGetUsersEnrichmentResponse>({
    path: '/sys/monitoring/users-enrichment',
    schema: getUsersEnrichmentResponseSchema,
  });
}
